module.exports = __webpack_public_path__ + "static/media/transfer-between-icon.8556f2d8.svg";